import { Badge } from '~/components/UI/Badge'
import { getRetailMediaAccountType } from '~/helpers'
import i18n from '~/i18n'

import ToogleActiveCampaignCategory from '../../../ToogleActiveCampaignCategory'

const renderSwitch = {
  active: {
    title: '',
    render: (rowData: CampaignCategory) => (
      <ToogleActiveCampaignCategory data={rowData} key={rowData.category_id} />
    ),
    width: 50
  }
}

export const schemaCategories = (): TableSchema<CampaignCategory> => {
  const accountType = getRetailMediaAccountType()

  return {
    ...(accountType === 'advertiser' ? { ...renderSwitch } : {}),
    title: {
      title: i18n.t('c:capitalize', {
        value: i18n.t('rm:category')
      }),
      render: rowData => {
        const isPaused = accountType === 'publisher' && !!rowData.disabled_at

        return (
          <>
            <span
              style={
                isPaused ? { color: 'var(--sl-fg-base-disabled)' } : undefined
              }
            >
              {rowData.name}
            </span>
            {isPaused && (
              <>
                {' '}
                <Badge template="warning">
                  {i18n.t('c:capitalize', {
                    value: i18n.t('rm:paused', { context: 'female' })
                  })}
                </Badge>
              </>
            )}
          </>
        )
      },
      className: 'order__details col__infos col__title',
      showTotal: true
    }
  }
}
